import { Provider } from '@angular/core';

// Injection token for the Http Interceptors multi-provider
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CsrfInterceptor } from './csrf-interceptor';

/** Provider for the Noop Interceptor. */
export const CsrfProvider: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: CsrfInterceptor,
  multi: true,
};
